import { useMutation } from '@tanstack/react-query';
import type { Customer, CustomerLookupBy } from '../types';
import { useCustomersSyncApi } from './use-customers-sync-api';
import { useCustomersSyncSettings } from './use-customers-sync-settings';

export function useUpdateCustomerGroups(lookupBy: CustomerLookupBy, identifier: string) {
  const { customersSyncApi } = useCustomersSyncApi();
  const settings = useCustomersSyncSettings();

  return useMutation<Customer, unknown, { sales_agent_groups: string[] }>({
    mutationFn: (payload) => customersSyncApi.updateGroups(lookupBy, identifier, payload, settings),
  });
}
